export class GeneradorColoresDistintos {
  private usados: string[] = [];
  private hueActual: number = Math.random(); // valor inicial aleatorio
  private readonly ratioConjugado: number = 0.618033988749895;
  private readonly saturacion: number = 0.65;
  private readonly luminosidad: number = 0.45;

  /**
   * Genera un color HSL bien distribuido y lo convierte a HEX.
   */
  private generarColorUnico(): string {
    this.hueActual = (this.hueActual + this.ratioConjugado) % 1;
    const h = Math.floor(this.hueActual * 360);
    const s = Math.floor(this.saturacion * 100);
    const l = Math.floor(this.luminosidad * 100);
    return this.hslAHex(h, s, l);
  }

  /**
   * Devuelve un nuevo color visualmente distinto a los ya dados.
   */
  public obtenerSiguienteColor(): string {
    let nuevoColor: string;
    let intentos = 0;

    do {
      nuevoColor = this.generarColorUnico();
      intentos++;
    } while (this.usados.includes(nuevoColor) && intentos < 100);

    this.usados.push(nuevoColor);
    return nuevoColor;
  }

  /**
   * Convierte HSL a formato HEX.
   */
  private hslAHex(h: number, s: number, l: number): string {
    s /= 100;
    l /= 100;

    const k = (n: number) => (n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n: number) =>
      Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))));

    const r = f(0).toString(16).padStart(2, "0");
    const g = f(8).toString(16).padStart(2, "0");
    const b = f(4).toString(16).padStart(2, "0");

    return `#${r}${g}${b}`;
  }
}
